// extracted by mini-css-extract-plugin
module.exports = {"tagsListContainer":"_2kS238mx","tagsListContent":"_2iGpwhOr","tagsListSideTray":"_2SPonZ_2","tagsListResults":"SSWCSyEn"};